import { SimpleDialog } from 'global/simple-dialog.src';

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    const previewBox = document.getElementById('preview-box');
    const previewUseBtn = document.querySelector('.preview-use-template');
    const previewIframe = document.querySelector('#preview-iframe');
    const desktop = document.querySelector('[data-view="desktop"]');
    const mobile = document.querySelector('[data-view="mobile"]');

    // set up simple dialog with full screen preview
    let previewDialog = {};
    if (previewBox) {
        previewDialog = new SimpleDialog(previewBox, {
            onOpen() {
                document.querySelector('body').style.overflow = 'hidden';
            },
            onClose() {
                document.querySelector('body').style.overflow = 'visible';
            },
        });
    }

    // close full screen preview
    document.querySelector('.preview-close').addEventListener('click', (e) => {
        if (previewBox) {
            e.preventDefault();
            e.stopPropagation();
            previewDialog.hide();

            // clear previous template preview so it's not visible before next one loads
            previewIframe.setAttribute('src', '');

            // switch back to desktop preview after hiding animation to prevent blinking change
            setTimeout(() => {
                desktop.closest('li').classList.add('active');
                mobile.closest('li').classList.remove('active');
                document.querySelector('#preview-box').classList.remove('mobile');
            }, 300);
        }
    });

    // open full screen preview
    document.querySelector('#ajax_dest').addEventListener('click', (e) => {
        if (previewBox && e.target.classList.contains('preview')) {
            e.preventDefault();
            previewDialog.show();

            // copy use-template-url and preview-url from thumbnail to full preview
            const useUrl = e.target.getAttribute('data-url');
            const previewUrl = e.target.getAttribute('data-preview');
            previewUseBtn.setAttribute('href', useUrl);
            previewIframe.setAttribute('src', previewUrl); // old url: https://${uuid}.grwebsite.com/
        }
    });

    // switch between desktop and mobile preview
    desktop.addEventListener('click', (e) => {
        e.preventDefault();
        desktop.closest('li').classList.add('active');
        mobile.closest('li').classList.remove('active');
        document.querySelector('#preview-box').classList.remove('mobile');
    });
    mobile.addEventListener('click', (e) => {
        e.preventDefault();
        mobile.closest('li').classList.add('active');
        desktop.closest('li').classList.remove('active');
        document.querySelector('#preview-box').classList.add('mobile');
    });
});
